module.exports = __webpack_public_path__ + "img/service2.3ae500f3.png";